import { Button, EmptyState } from "@aman/design-system";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

export function NotFoundPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return <EmptyState icon="404" title="Page not found" description="The requested route does not exist in Aman." action={<Button type="button" onClick={() => navigate("/")}>{t("common.back")}</Button>} />;
}
